/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let webinarListurl = root.webinarListUrl.link;
let createWebinarListurl = root.createWebinarListUrl.link;
let getPublicWebinarApiUrl = root.getPublicWebinarApiUrl.link;
export default {
  state: {
    getWebinarAllListState:{},
    getWebinarAllListOfAdminState:{},
    getWebinarDetailsByIdState:{},
    vistaConferenceState:{},
  },
  mutations: {
    getWebinarAllListMutation(state, value) {
      Vue.set(state, 'getWebinarAllListState', value);
    },
    getWebinarAllListOfAdminMutation(state, value) {
      Vue.set(state, 'getWebinarAllListOfAdminState', value);
    },
    getWebinarDetailsByIdMutation(state, value) {
      Vue.set(state, 'getWebinarDetailsByIdState', value);
    },
    vistaConferenceMutation(state, value) {
      Vue.set(state, 'vistaConferenceState', value);
    },
  },
  actions: {
    // vista confrence User Count
    vistaConferenceListFun(context, payload) {
            return new Promise((resolve, reject) => {
                axios.get(getPublicWebinarApiUrl, payload).then(res => {
                    context.commit('vistaConferenceMutation', res.data);
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            })
        },
    // get webinar all list
    getWebinarAllListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(createWebinarListurl + '?is_webinar=True', payload).then(res => {
                context.commit('getWebinarAllListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // get webinar all list Of Admin
    getWebinarAllListOfAdminFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(webinarListurl + '?is_webinar=True', payload).then(res => {
                context.commit('getWebinarAllListOfAdminMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // get webinar details by id
    getWebinarDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(createWebinarListurl + payload.id + '/').then(res => {
                context.commit('getWebinarDetailsByIdMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update webinar details by id
    updateWebinarDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(createWebinarListurl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // create webinar all list
    createWebinarListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(createWebinarListurl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    }
  },
  getters: {
    getWebinarAllListGetters : state => state.getWebinarAllListState,
    getWebinarAllListOfAdminGetters : state => state.getWebinarAllListOfAdminState,
    getWebinarDetailsByIdGetters : state => state.getWebinarDetailsByIdState,
    vistaConferenceGetters: state => state.vistaConferenceState
  }
}